import { Box, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomCheckbox,
  CustomDatePicker,
  CustomMenuItem,
  CustomRadioButton,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, useEffect, useRef } from "react";
import { ValidationError, object, string } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DietiesListByPoojaIdProps } from "../../../infrastructure/GlobalContextProvider";
import dayjs from "dayjs";
import { isEmpty, size } from "lodash";
import { PoojaTypeListProps } from "../../../infrastructure/GlobalContextProvider";
import { apiRequest } from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { isNil } from "lodash";
import CloseIcon from "@mui/icons-material/Close";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import { BounceLoader } from "react-spinners";
import { useReactToPrint } from "react-to-print";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";

const DailyReport = ({ sendDataToParent, getReportData }: any) => {
  const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>(0);
  const [selectedPoojaName, setSelectedPoojaName] = useState<any>("");
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [donationAmount, setDonationAmount] = useState(0);
  const [duration, setDuration] = useState(0);
  const [pageNumber, setPageNumber] = useState<number>(0);


  

  interface ErrorMessageTypesPooja {
    poojaTitle: string;
    searchbydonation: string;
  }

  const formData = {
    poojaTitle: "",
    searchbydonation: dayjs().format("MM/DD/YYYY"),
    poojaLocation: "TEMPLE_POOJA",
  };
  const validationSchemaForpooja = object().shape({
    poojaTitle: string().required("Pooja is required"),
    searchbydonation: string().required(
      "Search by Donation Date From is required"
    ),
  });

  const [errorMessageBookPooja, setErrorMessageBookPooja] =
    useState<ErrorMessageTypesPooja>({ ...formData });

  const [formDataBookPooja, setFormDataBookPooja] = useState(
    formData
  );
  const errors: ErrorMessageTypesPooja = {
    ...formData,
  };
  const [poojaDeitiesList, setPoojaDeitiesList] = useState<
    DietiesListByPoojaIdProps[]
  >([]);
  const [deityError, setDeityError] = useState<string>("");
  const [allDieties, setAllDieties] = useState<boolean>(false);
  const [selectedDeityIds, setSelectedDeityIds] = useState<number[]>([]);

  const handleCheckboxChange = (label: number) => {
    const isSelected = selectedDeityIds.includes(label);
    setDeityError("");
    if (isSelected) {
      setSelectedDeityIds(selectedDeityIds.filter((item) => item !== label));
    } else {
      setSelectedDeityIds([...selectedDeityIds, label]);
    }
  };

  const getPoojaBookingDailyReports = () => {
    let dieties = poojaDeitiesList.join(",");
    // if (poojaDeitiesList.length === 0) {
    //   setDeityError("Deity is Mandatory,Please Select Deity.");
    // } else {
      const reqBody = {
        poojaId: selectedPoojaId,
        poojaDate: formDataBookPooja.searchbydonation,
        deityIds:selectedDeityIds
      };
      setLoading(true);
      apiRequest({
        method: "POST",
        endpoint:
          "/report-dashboard/reports/pooja/POOJA_BOOKING_DAILY_REPORT/browser",
        body: JSON.stringify(reqBody),
        includeToken: true,
      })
        .then((res) => {
          setLoading(false);
          sendDataToParent(true, reqBody,selectedPoojaName);
          const response = res?.data?.map((obj: any) => {
            return {
              "Devotee Name(Sign-in Name)": `${obj.firstname} ${obj.middlename} ${obj.lastname} (${obj.username})`,
              "Nakshatram": obj.nakshtram || "--",
              "Gothram": obj.gothram || "--",
              "Amount": formatAmount(obj.amount),
            };
          });
          getReportData(response);

        })
        .catch((err) => {
          setLoading(false);
        });
    // }
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.poojaTypeByPoojaLocation,
      params: {
        poojaType: formDataBookPooja.poojaLocation,
      },
      includeToken: true,
    })
      .then((res) => {
        setPoojaItemsList(res.data);
      })
      .catch((err) => {
        console.log(err);
       
      });
  }, [formDataBookPooja.poojaLocation]);

  const getDeitiesListByPoojaId = (id: number | undefined) => {
    if (!isNil(id)) {
      apiRequest({
        method: "GET",
        endpoint: apiPath.deitiesListByPoojaId,
        includeToken: true,
        params: {
          poojaId: id,
        },
      })
        .then((res) => {
          setPoojaDeitiesList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    // Recalculate donation amount whenever currentItem or selectedItems change
    setDonationAmount(calculateDonationAmount(formDataBookPooja));
    setDuration(calculateDuration(formDataBookPooja));
    // setErrorMessage((prevState) => ({...prevState, donationAmount: ""}))
  }, [formDataBookPooja.poojaTitle, selectedDeityIds]);

  const calculateDonationAmount = (currentItem: any): number => {
    const isSelected = poojaDeitiesList.length > 0;
    const donationAmount = parseFloat(currentItem.donationAmount);
    return isSelected ? poojaDeitiesList.length * donationAmount : donationAmount;
  };

  const calculateDuration = (currentItem: any): number => {
    const isSelected = poojaDeitiesList.length > 0;
    const poojaDuration = parseFloat(currentItem.poojaDuration);
    return isSelected ? poojaDeitiesList.length * poojaDuration : poojaDuration;
  }

  const handlSubmitDailyreport = async () => {
    try {
      // Validate the form data against the validation schema
      await validationSchemaForpooja.validate(formDataBookPooja, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageBookPooja(errors);
      // Call your API or perform other actions here
      getPoojaBookingDailyReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesPooja] = e.message;
          }
        });
      }
      setErrorMessageBookPooja(errors);
    }
  };

  const handleClear = () => {
    setFormDataBookPooja(formData);
  };

  const handleDropdownChange = (field: any, value: any) => {
    if (field === "searchbydonation") {
      const formattedDate = dayjs(value, "MM/DD/YYYY");

      setFormDataBookPooja({
        ...formDataBookPooja,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormDataBookPooja({
        ...formDataBookPooja,
        [field]: value,
      });
    }
    if (field === "poojaTitle") {
      const selectedPooja = poojaItemsList.find(
        (item: PoojaTypeListProps) => item.id === value
      );
      setSelectedPoojaId(selectedPooja?.id);
      setSelectedPoojaName(selectedPooja?.name)
      getDeitiesListByPoojaId(selectedPooja?.id);
    }
  };

  const handleAllDeitiesChange = (event: any) => {
    const isChecked = event.target.checked;
    setAllDieties(isChecked);
    setDeityError("");
  };

 

  const PoojaListDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="month"
          handleDropdownChange={handleDropdownChange}
          errorMessage={""}
          dropDownList={poojaItemsList}
          value={formDataBookPooja.poojaTitle}
          fieldName="poojaTitle"
          placeholder="Select Pooja"
          optionLabel="name"
          optionValue="id"
          overrideStyles={{ backgroundColor: "white" }}
        />
      </FormControl>
    );
  };

  const DatePickerFrom = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formDataBookPooja.searchbydonation}
        handleDateChange={handleDropdownChange}
        errorMessage={undefined}
        name="searchbydonation"
        format="MM-DD-YYYY"  
        
      />
    );
  };

  const deitiesListComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        <div className={styles.checkBoxContainer}>
          {poojaDeitiesList.map((item: DietiesListByPoojaIdProps, index) => (
            <div className={styles.checkTitle}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    id={`${index}`}
                    size="medium"
                    className={styles.checkbox}
                    checked={selectedDeityIds.includes(item.deityId)}
                    onChange={() => handleCheckboxChange(item.deityId)}
                  />
                }
                label={item.deityName}
              />
            </div>
          ))}
        </div>
        {!isEmpty(deityError) ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {deityError}
          </Typography>
        ) : (
          ""
        )}
      </div>
    );
  };

  const [showButton, setShowButton] = useState(true);

const printStyles = `
 @page {
      size: tabloid;
      margin: 24px;
    }
 
    /* Set layout to Landscape */
    body {
      width: 100vw;
      position: absolute;
      background-color: #FFF9E4;
    }
}
`;

  const componentRef = useRef<any>(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:printStyles
  });


  
  const handleOpenDialog = () => {
    setOpenCancelDialog(true);
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
  };
  const PoojaDetailsComponent = () => {
   
    const selectedPooja = poojaItemsList.find(
      (item) => item.id === selectedPoojaId
    );

    return (
      <>
        <Grid ref={componentRef}>
          {selectedPooja && (
            <table className={styles.tableDetailsContainer} >
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Pooja Title</td>
                <td className={styles.contentTableColumn}>
                  : {selectedPooja.name}
                </td>
              </tr>
              <tr className={styles.headerTableRow} style={{ verticalAlign: "top" }}>
                <td className={styles.headerTableColumn}>Description/Material</td>
                <td className={styles.contentTableColumn}>: {!isNil(selectedPooja.description) ? selectedPooja.description : "-"}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Duration</td>
                <td className={styles.contentTableColumn}>
                  : {selectedPooja.duration.toString()}
                </td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Suggested Donation</td>
                <td className={styles.contentTableColumn}>: {selectedPooja.suggestedDonation.toString()}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Priest Required</td>
                <td className={styles.contentTableColumn}>
                  : {selectedPooja.priestRequired ? "Yes" : "No"}
                </td>
              </tr>
            </table>
          )}
        </Grid>
        {showButton &&<Grid sx={{ marginTop: "10px" }}>
          <CommonButton onClick={handlePrint} className={styles.printHidden} >
            Print
          </CommonButton>
        </Grid>}
      </>
    );
  };


  return (
    <div className={styles.poojareportsLayout}>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja Location", true)}
          <CustomRadioButton
            checked={formDataBookPooja.poojaLocation === "TEMPLE_POOJA"}
            onChange={() => {
              handleDropdownChange("poojaLocation", "TEMPLE_POOJA");
            }}
            id="templeLocation"
          />
          <label className={styles.label}>Temple Pooja</label>
          <CustomRadioButton
            checked={formDataBookPooja.poojaLocation === "OUTSIDE_POOJA"}
            onChange={() => {
              handleDropdownChange("poojaLocation", "OUTSIDE_POOJA");
            }}
            id="outLocation"
          />
          <label className={styles.label}>Outside Pooja</label>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div id="SelectPooja">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: { xs: "85%", sm: "100%" },
              }}
            >
              {CustomRequiredInputLabel("Pooja", true)}
              <p
                style={{
                  color: selectedPoojaId ? "blue" : "#73737e",
                  margin: "0 0 2px",
                  cursor: selectedPoojaId ? "pointer" : "not-allowed",
                }}
                // onClick={handleOpenDialog}
                onClick={selectedPoojaId ? handleOpenDialog : () => {}}
              >
                Details
              </p>
            </Box>
            {PoojaListDropdown()}
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search by Donation Date From", false)}
          {DatePickerFrom()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {poojaDeitiesList.length > 0 &&
            CustomRequiredInputLabel("Deities", false)}
          {deitiesListComponent()}
        </Grid>
       
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitDailyreport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
      <Dialog
        open={openCancelDialog}
        onClose={handleCancelDialogClose}
        aria-labelledby="cancel-dialog-title"
        PaperProps={{
          style: {
            margin: "64px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <div
          style={{
            backgroundColor: "#882E14",
            width: "auto",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
          >
            {"Pooja Details"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCancelDialogClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogContent sx={{ backgroundColor: "#FFF9E4" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BounceLoader color="#22A699" loading={loading} size={45} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Please wait...
              </span>
            </div>
          ) : (
            <div>
              {PoojaDetailsComponent()}
              {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default DailyReport;
